// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PVerticalRightOutlinedSvg from "@fishx/icons-svg/es/asn/PVerticalRightOutlined";
import FishxIcon from '../components/FishxIcon';

var PVerticalRightOutlined = function PVerticalRightOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PVerticalRightOutlinedSvg
  }));
};

PVerticalRightOutlined.displayName = 'PVerticalRightOutlined';
export default React.forwardRef(PVerticalRightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PVerticalRightOutlined.js
// module id = 3730
// module chunks = 0